<section class="stacksBlockContainer" id="block-products">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>

  <!-- Sidebar -->
  <div *ngIf="checkSidebar()" class="blockSidebar" [ngClass]="builderService.standalone ? '' : 'disabled'" (click)="appendBlock($event)">
    <img src="assets/icons/cube.svg" alt="" />
    <p>{{ 'Vendor`s Products' | translate }}</p>
  </div>

  <!-- Mobile Preview -->
  <div
    class="previewProducts previewMobile"
    [ngClass]="[
      getBlockFields(blockId)?.style?.products_style ? getBlockFields(blockId)?.style?.products_style : '',
      getBlockFields(blockId)?.style?.productColumns ? getBlockFields(blockId)?.style?.productColumns : ''
    ]"
    *ngIf="checkPreview() && getBlockFields(blockId)"
    id="{{ 'blockid' + blockId }}"
    cdkDrag
    [cdkDragData]="blockId"
  >
    <mat-progress-bar mode="indeterminate" *ngIf="builderService.showSettingsProgress"></mat-progress-bar>

    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId)">
        <mat-icon>close</mat-icon>
      </div>
    </div>

    <div class="blockPlaceholder" *cdkDragPlaceholder></div>

    <div
      [id]="getBlockFields(blockId)?.style?._element_id"
      [ngClass]="toNgClass(
        getBlockFields(blockId)?.style?._css_classes,
        getBlockFields(blockId)?.style?.products_style,
        getBlockFields(blockId)?.style?.productColumns
      )"
    >
      <div [ngClass]="toNgClass(getBlockFields(blockId)?.style?.products_style)">
        <div class="horizontal-slider-container" [ngClass]="toNgClass(getBlockFields(blockId)?.style?.displayStyle)">
          <p *ngIf="getProductsData(blockId) && !getProductsData(blockId)[0]" style="color: red">
            {{ 'No Products Available with the selected settings' | translate }}
          </p>

          <ul class="horizonal-slider" [ngClass]="toNgClass(getBlockFields(blockId)?.style?.productColumns)">
            <li class="item" *ngFor="let product of getProductsData(blockId)">
              <div class="flex-container">
                <div class="picture-container">
                  <img [src]="product?.imageUrl | primaryImage" alt="" />
                  <div class="sale" *ngIf="product?.salePrice && product?.salePrice !== '0.00'">{{ 'Sale' }}!</div>
                </div>

                <!-- Clean Style quick-add — mirrors stacks-products so the multivendor
                     preview shows what the app actually renders. -->
                <div class="cleanBtn" *ngIf="getBlockFields(blockId)?.style?.products_style == 'cleanStyle'">
                  <button
                    type="button"
                    [ngStyle]="{ color: getBlockFields(blockId)?.style?.color }"
                    [ngClass]="{ outOfStockCart: helpers.isOutOfStock(product), isAdded: product?.justAdded }"
                    [disabled]="helpers.isOutOfStock(product)"
                    (click)="helpers.flashAdded(product); $event.stopPropagation()"
                    [attr.aria-label]="
                      helpers.isOutOfStock(product)
                        ? ('Out Of Stock' | translate)
                        : (helpers.hasVariations(product) ? ('View Product' | translate) : ('Add to Cart' | translate))
                    "
                  >
                    <mat-icon class="material-icons-outlined">{{ product?.justAdded ? 'check' : (helpers.hasVariations(product) ? 'tune' : 'add') }}</mat-icon>
                  </button>
                </div>

                <div class="fade">
                  <div class="description" [ngClass]="product?.productStock == '' || product?.productStock == '0' || product?.productStock == 0 || product?.stock_status == 'outofstock' ? 'outofStockItem' : ''">
                    <div class="heading" [ngClass]="getBlockFields(blockId)?.style?.nameOverflow || 'short'">
                      <div class="headingName">{{ product?.productName }}</div>
                    </div>
                    <div class="vendorBadge" *ngIf="selectedVendorId === 'ALL' && product._vendorName && getBlockFields(blockId)?.style.nameVisibility === 'showName'">
                      {{ product._vendorName }}
                    </div>

                    <div *ngIf="product?.productVariations?.length > 1" class="pricesWrapper">
                      <div class="pricesMiniWrapper">
                        <div class="mainPrice" *ngIf="product.lowestSalePrice">
                          <span class="currency-symbol">{{ settingsService.currency }}</span>
                          {{ product?.lowestSalePrice }}
                        </div>
                        <div class="strike" *ngIf="product.lowestSalePrice">
                          <span class="currency-symbol">{{ settingsService.currency }}</span>
                          {{ product?.correspondingRegularPrice }}
                        </div>
                      </div>

                      <div class="price mainPrice" *ngIf="!product.lowestSalePrice">
                        <span class="currency-symbol">{{ settingsService.currency }}</span>
                        {{ product?.lowestRegularPrice }}
                      </div>
                    </div>

                    <div *ngIf="product?.productVariations?.length <= 1" class="pricesWrapper" [ngClass]="product?.productStock == '' || product?.productStock == '0' || product?.stock_status == 'outofstock' ? 'outofstockPriceWrapper' : ''">
                      <div class="price pricesMiniWrapper" *ngIf="product?.salePrice !== '0.00' && product?.salePrice !== '' && product?.salePrice !== '0' && product?.salePrice">
                        <div class="mainPrice"><span class="currency-symbol">{{ settingsService.currency }}</span>{{ product?.salePrice }}</div>
                        <div class="strike"><span class="currency-symbol">{{ settingsService.currency }}</span>{{ product?.regularPrice }}</div>
                      </div>
                      <div class="savePill" *ngIf="helpers.cleanSavings(getBlockFields(blockId)?.style, product) as savings">
                        {{ 'Save' | translate }} <span class="currency-symbol">{{ settingsService.currency }}</span>{{ savings }}
                      </div>

                      <div class="price mainPrice" *ngIf="product?.salePrice == '0.00' || product?.salePrice == '' || !product?.salePrice">
                        <span class="currency-symbol">{{ settingsService.currency }}</span>{{ product?.regularPrice }}
                      </div>

                      <span *ngIf="(getBlockFields(blockId).style?.products_style == 'glassStyle' || getBlockFields(blockId).style?.products_style == 'sharpStyle') && (product?.productStock == '' || product?.productStock == '0' || product?.stock_status == 'outofstock')" class="outofstock">{{ 'Out Of Stock' }}</span>
                    </div>

                    <span *ngIf="getBlockFields(blockId).style?.products_style !== 'glassStyle' && getBlockFields(blockId).style?.products_style !== 'sharpStyle' && (product?.productStock == '' || product?.productStock == '0' || product?.stock_status == 'outofstock')" class="outofstock">{{ 'Out Of Stock' }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Tab -->
  <div class="previewFields" *ngIf="checkData() && getBlockFields(blockId)">
    <mat-progress-bar mode="indeterminate" *ngIf="builderService.showSettingsProgress"></mat-progress-bar>

    <!-- Vendor Source -->
    <h4 class="listTitle">{{ 'Vendor Source' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Source' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('source', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.source">
          <mat-option value="all">{{ 'All Vendors' | translate }}</mat-option>
          <mat-option value="by_id">{{ 'Choose Vendors' | translate }}</mat-option>
        </mat-select>
      </li>
      <li *ngIf="getBlockFields(blockId).data?.source === 'by_id'">
        <mat-label>{{ 'Vendors' | translate }}</mat-label>
        <mat-select multiple (selectionChange)="queryChange('vendors', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.vendors">
          <mat-option *ngFor="let v of vendors" [value]="v.id">{{ v.name || v.id }}</mat-option>
        </mat-select>
      </li>
    </ul>

    <!-- Query (same as products) -->
    <h4 class="listTitle">{{ 'Query' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Source' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('query_post_type', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.query_post_type">
          <mat-option value="product">{{ 'Latest Products' | translate }}</mat-option>
          <mat-option value="by_category">{{ 'Products Categories' | translate }}</mat-option>
        </mat-select>
      </li>
    </ul>

    <ul>
      <li *ngIf="getBlockFields(blockId).data.query_post_type == 'by_category'">
        <mat-label>{{ 'Categories' | translate }}</mat-label>
        <mat-select multiple (selectionChange)="queryChange('products_categories', blockId, $event, 'select')" [value]="getBlockFields(blockId).data.products_categories">
          <mat-option *ngFor="let productCategory of getCategoriesData(blockId)" [value]="productCategory.categoryId">
            {{ productCategory.categoryName }}
          </mat-option>
        </mat-select>
      </li>

      <li *ngIf="getBlockFields(blockId).data.query_post_type == 'by_category' && allowedSubcategories.length">
        <mat-label>{{ 'SubCategories' | translate }}</mat-label>
        <mat-select multiple (selectionChange)="queryChange('products_sub_categories', blockId, $event, 'select')" [value]="getBlockFields(blockId).data.products_sub_categories">
          <mat-option *ngFor="let productSubCategory of allowedSubcategories" [value]="productSubCategory.subCategoryId">
            {{ productSubCategory.subcategory }}
          </mat-option>
        </mat-select>
      </li>
    </ul>

    <ul>
      <li>
        <mat-label>{{ 'Limit' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="50" min="1" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).data?.limit" (change)="queryChange('limit', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>

    <ul>
      <li>
        <mat-label>{{ 'Order By' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('query_orderby', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.query_orderby">
          <mat-option value="date">{{ 'Date' | translate }}</mat-option>
          <mat-option value="title">{{ 'Title' | translate }}</mat-option>
          <mat-option value="price">{{ 'Price' | translate }}</mat-option>
        </mat-select>
      </li>
    </ul>

    <ul>
      <li>
        <mat-label>{{ 'Order' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('query_order', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.query_order">
          <mat-option value="ASC">{{ 'Ascendingly' | translate }}</mat-option>
          <mat-option value="DESC">{{ 'Descendingly' | translate }}</mat-option>
        </mat-select>
      </li>
    </ul>
  </div>

  <!-- Style Tab (copy of products style controls) -->
  <div class="styleFields" *ngIf="checkStyle() && getBlockFields(blockId)">
    <ul>
      <li>
        <mat-label>{{ 'List Style' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('displayStyle', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.displayStyle">
          <mat-option value="gridStyle">{{ 'Grid Style' | translate }}</mat-option>
          <mat-option value="listStyle">{{ 'Columns Style' | translate }}</mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Columns Style' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('productColumns', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.productColumns">
          <mat-option value="oneColumn">{{ 'One Column' | translate }}</mat-option>
          <mat-option value="twoColumns">{{ 'Two Columns' | translate }}</mat-option>
          <mat-option value="threeColumns">{{ 'Three Columns' | translate }}</mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Product Style' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('products_style', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.products_style">
          <mat-option value="simpleStyle">{{ 'Simple Style' | translate }}</mat-option>
          <mat-option value="glassStyle">{{ 'Glass Style' | translate }}</mat-option>
          <mat-option value="sharpStyle">{{ 'Sharp Style' | translate }}</mat-option>
          <mat-option value="roundedStyle">{{ 'Rounded Style' | translate }}</mat-option>
          <mat-option value="cleanStyle">
            {{ 'Clean Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Name' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameVisibility', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameVisibility">
          <mat-option value="hideName">{{ 'Hide Name' | translate }}</mat-option>
          <mat-option value="showName">{{ 'Show Name' | translate }}</mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Product Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameOverflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameOverflow || 'short'">
          <mat-option value="full">{{ 'Show Full Name' | translate }}</mat-option>
          <mat-option value="short">{{ 'Shorten long names (…)' | translate }}</mat-option>
        </mat-select>
      </li>
    </ul>

    <h4 class="listTitle">{{ 'Colors' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li class="contentCenter contentContainerColor">
        <mat-label>{{ 'Button Text Color' | translate }}</mat-label>
        <mat-form-field>
          <p class="colorPickerValue">{{ getBlockFields(blockId).style?.color }}</p>
          <label for="color" class="colorLabel">
            <input type="color" id="color" matInput class="colorPicker" name="color" (change)="styleChange('color', blockId, $event, 'text')" [value]="getBlockFields(blockId).style?.color" />
          </label>
        </mat-form-field>
      </li>
    </ul>

    <h4 class="listTitle">{{ 'Margins' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Margin Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['margin-top']?.slice(0, -2)" (change)="styleChange('margin-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['margin-right']?.slice(0, -2)" (change)="styleChange('margin-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['margin-bottom']?.slice(0, -2)" (change)="styleChange('margin-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['margin-left']?.slice(0, -2)" (change)="styleChange('margin-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>

    <mat-label>{{ 'Paddings' | translate }}</mat-label>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Padding Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['padding-top']?.slice(0, -2)" (change)="styleChange('padding-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['padding-right']?.slice(0, -2)" (change)="styleChange('padding-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['padding-bottom']?.slice(0, -2)" (change)="styleChange('padding-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb [ngModel]="getBlockFields(blockId).style['padding-left']?.slice(0, -2)" (change)="styleChange('padding-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
  </div>
</section>
